import * as account from './account';
import * as model from './model';
import * as section from './section';
import * as attendance from './attendance';
import * as attendanceGroup from './attendanceGroup';
import * as coreLine from './coreLine';
import * as coreLineAttendance from './coreLineAttendance';
import * as filter from './filter';
import * as indicators from './indicators';
import * as preRegistrationLink from './preRegistrationLink';
import * as documents from './documents';

export default ({
  account,
  model,
  section,
  attendance,
  attendanceGroup,
  coreLine,
  filter,
  coreLineAttendance,
  indicators,
  preRegistrationLink,
  documents,
});